import Container from "./container";
import logo from "../../assets/images/logo/Asset 2@3x.png";
import { useTranslation } from "../../context/LanguageContext";

function Header() {
  return (
    <header className="bg-primary h-[120px] flex items-center">
      <Container>
        <div className="flex items-center justify-between w-full">
          <a href="/">
            <img src={logo} alt="Ohmi" width={121} height={77} />
          </a>
          <Menus />
        </div>
      </Container>
    </header>
  );
}

export default Header;
function Menus() {
  const { locale, translate } = useTranslation();

  const data = [
    {
      id: 1,
      name: translate("menu.home"),
      url: "/",
    },
    {
      name: translate("menu.about"),
      url: "#about",
    },
    {
      name: translate("menu.store"),
      url: "#product",
    },

    {
      name: translate("menu.news"),
      url: "/news",
    },
    {
      name: translate("menu.contact"),
      url: locale === "kr" ? "/contact" : "https://www.facebook.com/profile.php?id=61567462526332",
    },
  ];
  return (
    <ul className="flex items-center gap-px">
      {data?.map((item, index) => {
        return (
          <li key={index}>
            <a
              className="text-white px-5 pt-4 pb-3.5 text-lg rounded-full font-semibold hover:bg-white hover:text-black transition-all duration-300"
              href={item?.url}
            >
              {item?.name}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
